import angular from "angular";

export function registerToasterListeners(moduleName = "ccqapp") {
    angular.module("ccqapp").run(($rootScope: ng.IRootScopeService, toaster: any) => {
        // show sticky
        $rootScope.$on("download-init", () => {
            toaster.pop({
                type: "info",
                title: "Preparing download",
                body: "The download is starting, please wait...",
                timeout: 0, // sticky
            });
        });

        // clear sticky when server responds
        $rootScope.$on("download-start", () => {
            try { toaster.clear(); } catch { }
        });

        // success toast (auto hides)
        $rootScope.$on("downloaded", (_evt, _blob, filename) => {
            try { toaster.clear(); } catch { }
            toaster.pop({
                type: "success",
                title: "Download ready",
                body: filename ? `Saved: ${filename}` : "Your file is ready.",
                timeout: 3000,
            });
        });

        // failure toast (auto hides)
        $rootScope.$on("download-failed", (_evt, message) => {
            try { toaster.clear(); } catch { }
            toaster.pop({
                type: "error",
                title: "Download failed",
                body: message || "Something went wrong.",
                timeout: 5000,
            });
        });
    });
}
